import useInView from '../hooks/useInView';
import { useLanguage } from '../context/LanguageContext';

const LAKE_IMG = 'https://customer-assets.emergentagent.com/job_04606eda-c805-4e3a-af14-63242db4ed24/artifacts/ng9te5l9_IMG_2726.JPG';

const Story = () => {
  const [ref, inView] = useInView(0.08);
  const { t } = useLanguage();

  return (
    <section id="story" data-testid="story-section" className="bg-winery-muted py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12" ref={ref}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">

          {/* Text — left */}
          <div className="lg:col-span-6">
            <div className={`reveal ${inView ? 'visible' : ''}`}>
              <span className="section-label">{t.story.label}</span>
              <div className="line-gold mt-4 mb-8" />
            </div>

            <h2
              className={`reveal reveal-delay-1 font-heading font-light text-obsidian leading-tight mb-8 ${inView ? 'visible' : ''}`}
              style={{ fontSize: 'clamp(2rem, 4vw, 3.2rem)' }}
            >
              {t.story.heading[0]}<br />{t.story.heading[1]}
            </h2>

            <div className={`reveal reveal-delay-2 space-y-5 font-body text-winery-text text-base leading-relaxed ${inView ? 'visible' : ''}`}>
              <p>{t.story.para1}</p>
              <p>{t.story.para2}</p>
              <p>{t.story.para3}</p>
              <p className="text-obsidian font-light" style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: '1.15rem', fontStyle: 'italic' }}>
                {t.story.closing}
              </p>
            </div>
          </div>

          {/* Image — right */}
          <div className={`reveal reveal-delay-3 lg:col-span-6 ${inView ? 'visible' : ''}`}>
            <div className="relative overflow-hidden" style={{ aspectRatio: '4/5' }}>
              <img
                src={LAKE_IMG}
                alt="The estate lake in autumn"
                className="w-full h-full object-cover parallax-img"
                loading="lazy"
              />
              <div className="absolute bottom-4 left-4 right-4">
                <p className="font-body text-xs tracking-widest uppercase text-white/70 bg-black/20 backdrop-blur-sm px-3 py-2 inline-block">
                  {t.story.caption}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
